import { inject } from '@angular/core';
import{  CanActivateFn, Router } from '@angular/router' ;
import { StorageService } from '../storage/storage.service';
import { UserMetadata } from 'src/app/models/UserMetadata';
import { ToastService } from '../toast/toast.service';
import { Constants } from 'src/app/constants/constants';

export const authGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  const storageService: StorageService = inject(StorageService);
  const toastService: ToastService = inject(ToastService);

  let userMetadata: UserMetadata = storageService.getItem('user_metadata');
  if(!userMetadata) {
    toastService.showToast(Constants.ERROR, 'Not logged in!', 'You need to login first before accessing this portal!');
    router.navigateByUrl('/login');
  }

  return userMetadata && userMetadata.access_token ? true : false;
}
